import type { OktaAuth } from "@okta/okta-auth-js";
import axios from "axios";

// Tenants API Endpoints
export const TENANTS_LIST = "/v1/admin_panel/tenants";
export const TENANT_ADMIN_USER = (tenantId: string) =>
	`/v1/admin_panel/users/${tenantId}`;

export const API = axios.create({
	baseURL: `${process.env.VITE_APP_API_URL}`,
	headers: {
		accept: "application/json",
		"Content-Type": "application/json",
	},
});

export const setupApiInterceptor = (oktaAuth: OktaAuth) => {
	API.interceptors.request.use(async (config) => {
		const accessToken = oktaAuth.getAccessToken();
		if (accessToken) {
			config.headers.Authorization = `Bearer ${accessToken}`;
		}
		return config;
	});
};
